<template>
  <v-checkbox
      v-model="order.payment.confirmed"
      @change="paymentConfirm"
      :disabled="loading"
      color="green"
  ></v-checkbox>
</template>

<script>
import OrderProvider from "@/modules/delivery/providers/OrderProvider";

export default {
  name: "OrderPaymentConfirmed",
  props: {
    order: {type: Object},
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    paymentConfirm(val) {
      this.loading = true
      OrderProvider.updateOrderPaymentConfirm({orderId: this.order.id, confirmed: val})
          .then(r => {
            this.$emit('orderUpdated', r.data.updateOrderPaymentConfirm)
          })
          .finally(() => this.loading = false)
    }
  },
}
</script>

<style scoped>

</style>
